module.exports = __webpack_public_path__ + "fone.png?fbc51fd6a2d5d652468cb9e521b86613";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fone.png
// module id = 61
// module chunks = 0